<template>
    <div class="dia_container" v-loading="loading" element-loading-text="密码数据加载中！">
        <div class="form_line">
            <label class="">请选择该租户新增账号的密码生成方式：</label>
            <div class="cl password-set-line">
                <div class="l"><el-radio class="radio" v-model="passwordType" label="1">随机密码</el-radio></div>
                <div class="l ml10">
                    <el-radio class="radio l" v-model="passwordType" label="2">指定密码</el-radio>
                    <div class="l ml10"><el-input v-if="passwordType == '2'" v-model="password"></el-input></div>
                </div>
            </div>
        </div>
        <div class="dia_btn_container">
            <el-button @click="cancel">取消</el-button>
            <el-button type="primary" @click="saveInitPassword">保存</el-button>
        </div>
    </div>
</template>
<script>
    import { errorMessage } from '../../../util'
    export default {
        props: ['param'],
        data() {
            return {
                passwordType: "1",
                password: '',
                loading: false
            }
        },
        created() {
            this.init()
        },
        methods: {
            init() {
                this.loading = true
                this.$http.post(`/platserv/tenant/getInitPassword`,{
                    tenantcode: this.param.tenantCode
                }).then(res => {
                    let password = res.data.resp_data
                    this.passwordType = password ? '2' : '1'
                    this.password = password
                    this.loading = false
                }).catch(error => {
                    this.loading = false
                    errorMessage(error, this)
                })
            },
            // 保存初始密码
            saveInitPassword() {
                let password = this.passwordType === '1' ? '' : this.password
                this.$http.post(`/platserv/tenant/saveInitPassword`,{
                    password,
                    tenantcode: this.param.tenantCode
                }).then(function(res){
                    this.$message.success('保存成功！')
                    this.cancel()
                }).catch(error => {
                    errorMessage(error, this)
                })
            },
            cancel() {
                this.$emit('cancel')
            }
        }
    }
</script>


// WEBPACK FOOTER //
// SettingPassword.vue?c8630ce2